module.exports = __webpack_public_path__ + "img/06_food6.2cd885bc.png";